import { AutosuggestListOption } from "@/core/components/Autosuggest/Autosuggest";
import { AirData } from "@/core/types/types";

export function filterAirOptions(
  options: AutosuggestListOption[],
  input: string
) {
  if (isAirDataList(options)) {
    const filteredOptions = options.filter(
      (option) =>
        option.name.toLowerCase().includes(input) ||
        option.iata.toLowerCase().startsWith(input)
    );

    const sortedOptions = filteredOptions.sort((a, b) => {
      const aExactMatch = a.iata.toLowerCase() === input;
      const bExactMatch = b.iata.toLowerCase() === input;

      if (aExactMatch !== bExactMatch) {
        return aExactMatch ? -1 : 1;
      }

      const aStartsWith = a.iata.toLowerCase().startsWith(input);
      const bStartsWith = b.iata.toLowerCase().startsWith(input);

      if (aStartsWith !== bStartsWith) {
        return aStartsWith ? -1 : 1;
      }

      return 0;
    });

    return sortedOptions.length ? sortedOptions : options;
  }

  return options;
}

export function isAirDataList(
  options: AutosuggestListOption[]
): options is AirData[] {
  return options.every(isAirData);
}

export function isAirData(
  option: AutosuggestListOption | null
): option is AirData {
  return !!option && "iata" in option;
}

export function stringifyAirData(value: AirData) {
  return `${value.name}${value.iata ? ` - ${value.iata}` : ""}`;
}
